export default __webpack_public_path__ + "static/media/twitter.b379a7c5.svg";